import script from "./zrjs.vue?vue&type=script&setup=true&lang=js"
export * from "./zrjs.vue?vue&type=script&setup=true&lang=js"

import "./zrjs.vue?vue&type=style&index=0&id=14cb91a6&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14cb91a6"]])

export default __exports__